import React, { useState } from "react";
import Container from "./container";
import Icon from "./icon";
import ImageG from "./image-g";
import PortableText from "./portableText";
import ReactPlayer from 'react-player';
import { cn } from "../lib/helpers";

import * as styles from "../styles/components/fc-video-page.module.css";

interface Image {
  asset?: {
    _id?: string;
  }
  alt?: string;
  _rawCaption: any[];
}

interface VideoPageProps {
  url?: string;
  thumbnail?: Image;
}

const VideoPage: React.FC<VideoPageProps> = ({ 
  url,
  thumbnail,
}) => {
  if (!url || !thumbnail?.asset) {
    return null;
  }

  const [playVideo, setPlayVideo] = useState(false);

  const handlePlay = () => {
    setPlayVideo(true);
  }

  return (
    <div className={styles.root}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.video}>
            <div className={styles.cover}>
              <ImageG node={thumbnail} alt={thumbnail.alt} />
            </div>
            <div className={styles.action} onClick={handlePlay} onKeyDown={handlePlay} role="button" tabIndex={0}><Icon symbol="play" /></div>
            <div className={cn(styles.player, playVideo && styles.active)}>
              <ReactPlayer 
                url={url}
                playing={playVideo}
                controls={true}
                width="100%"
                height="100%"
              />
            </div>
          </div>
          {thumbnail._rawCaption && (
            <div className={cn("entry-content", styles.caption)}>
              <PortableText blocks={thumbnail._rawCaption} />
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default VideoPage;
